import { AbstractMessageCommand } from 'flux-connection';
import { Injectable } from '@angular/core';
import { Command, CommandInterfaces } from 'flux-core';
import { DataStore } from 'flux-store';
import { CommentModel } from '../../diagram/model/comment.mdl';
import { tap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * This command will delete a comment on the diagram. Delete will only delete the
 * comment text. It will preserve the rest of the comment data to indicate there
 * is a comment and it is deleted.
 */
@Injectable()
@Command()
export class DeleteComment extends AbstractMessageCommand {

    /**
     * Input data definition
     */
    public static get dataDefinition(): {}  {
        return {
            commentId: true,
        };
    }

    /**
     * List of commands which will be used by this class.
     */
    public static get implements(): CommandInterfaces[] {
        return [
            'IMessageCommand',
            'IDiagramCommand',
            'ICollabCommand',
        ];
    }

    constructor(
        protected dataStore: DataStore,
    ) {
        super()/* istanbul ignore next */;
    }

    public get version(): number {
        return 2;
    }

    /**
     * Data preperation before the execution.
     */
    public prepareData() {
        this.previousData = {};
        return this.dataStore.findOne( CommentModel, { id: this.data.commentId, diagramId: this.resourceId }).pipe(
                        take( 1 ),
                        tap( c => this.previousData.comment = c.comment ),
                    );
    }

    /**
     * This function update the datastore with the new comment model.
     */
    public execute() {
        return this.dataStore.update( CommentModel,
                { id: this.data.commentId, diagramId: this.resourceId },
                {
                    $set: { deleted: new Date().getTime(), comitted: false },
                    $unset: { comment: '' },
                });
    }

    /**
     * This function commits the changes to the datastore upon the success of
     * the execution.
     * @param response - Response data of the request.
     */
    public executeResult( response: any ) {
        return this.dataStore.update( CommentModel,
                { id: this.resultData.comment.id, diagramId: this.resourceId },
                {
                    $set: { deleted: response.comment.deleted, comitted: true },
                    $unset: { comment: '' },
                });
    }

    /**
     * This function roll back the changes from the datastore upon the
     * failure of the execution.
     */
    public revert(): Observable<any> {
        return this.dataStore.update(
                CommentModel,
                { id: this.data.commentId, diagramId: this.resourceId },
                {
                    $set: { comment: this.previousData.comment },
                    $unset: { deleted: '' },
                });
    }
}

Object.defineProperty( DeleteComment, 'name', {
    value: 'DeleteComment',
});
